import React from 'react';
import styled from '@emotion/styled/macro';

const GroupedTableRow = ({ children, className }) => {
  if (children) {
    return (
      <tr className={className} data-testid="grouped-table-row">
        {children}
      </tr>
    );
  } else {
    console.warn(
      'GroupedTableRow received invalid arguments - children:',
      children
    );
    return null;
  }
};

const StyledGroupedTableRow = styled(GroupedTableRow)``;

export default StyledGroupedTableRow;
